import React from 'react';
import { Upload, Toast, Icon } from '@iyunbao/components';

import fetchAPI from '../../utils/fetchAPI';
import config from '../../config';

export interface InputProps {
  prefixCls?: string;
  type?: 'idcard' | 'bankcard';
  onChange?: (value: string) => void;
  onLog?: (name: string) => void;
}

// 表单 输入框组件
function ImageOCR(props: InputProps) {
  const {
    prefixCls = 'crm-input',
    type,
    onLog,
    onChange,
  } = props;

  if (!(type && ['idcard', 'bankcard'].indexOf(type) > -1)) {
    return null;
  }

  function onChangeUpload(file: any) {
    const { thumbnail } = file || {};

    // 用于埋点标记，回调
    onLog && onLog('imageORC');

    if (!thumbnail) {
      Toast.warning('识别失败，请手动输入');
      return false;
    }

    const data: any = {
      imageType: type,
      // 接口需要去除前面 data:image/jpg;base64,
      image: thumbnail.replace(/^data:(\w+\/\w+;)?base64,/, ''),
    };

    // 识别ocr 身份证正面识别
    // "id_card_side": "front：身份证含照片的一面；back：身份证带国徽的一面"
    if (type === 'idcard') {
      data.id_card_side = 'front';
    }

    const params = {
      url: `${config.lite.host}/open/v1/lite/wx/common/baidu/imageOCR/base64`,
      isLoading: true,
      method: 'POST',
      data,
    };

    fetchAPI
      .fetchResult(params)
      .then(({ code, result }) => {
        try {
          if (code === 0 && result && result.result) {
            // 识别银行卡
            if (result.result.bank_card_number) {
              const bankCard = result.result.bank_card_number.replace(/\s/g, '');
              onChange && onChange(bankCard);
            // 识别身份证
            } else if (result.result.words_result) {
              onChange && onChange(result.result.words_result['公民身份号码'].words);
            }
          }
        } catch (error) {
          console.error(error);
        }
      })
      .catch((message: string) => {
        if (typeof message === 'string') {
          Toast.warning(message);
        }
      });
  }

  return (
    <Upload
      className={`${prefixCls}-upload`}
      onChange={(file) => onChangeUpload(file)}
      quality={0.8}
    >
      <Icon type="saomiao" />
    </Upload>
  );
}

export default ImageOCR;
